<template>
  <b-collapse id="searchForm" v-model='showSearch' class="bg-light p-2">
    <b-card class="mt-1 ">
      <b-input-group prepend="Search for" class="input-med">
        <b-form-input v-on:keyup.native="_search" v-model="q"></b-form-input>
      </b-input-group>
      <b-form inline class="mt-2 searchOptions">
        <label class="mr-sm-2 searchLocationsText" for="searchLocations">Search in</label>
        <b-form-select v-model="scope" class="mb-2 mr-sm-3 mb-sm-0 w-40"
                       :options="options"
                       id="searchLocations">
          <option slot="first" :value="null">Choose...</option>
        </b-form-select>
        <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0">
          Exclude Duplicates
        </b-form-checkbox>
        <!-- <b-button type="light" class="btn-xs">Search</b-button> -->
      </b-form>
    </b-card>
    <div class="select-item-options">
      <b-list-group class='search-list-group'>
        <b-list-group-item href="#" v-for="(option, index) in results" @click.prevent="selectItem(option)" :key="index + '_' + option.name">{{option['label']}}</b-list-group-item>
        <template v-if="!results.length && showNotFound">
          <li class="list-group-item bg-light"><span class="not-found-label">{{notFoundText}}</span></li>
        </template>
      </b-list-group>
    </div>
  </b-collapse>
</template>
<script>

import VectorLayer from 'ol/layer/Vector'
import TileLayer from 'ol/layer/Tile'
import Point from 'ol/geom/Point'
import {boundingExtent} from 'ol/extent'
import * as olProj from 'ol/proj'
import WktFormat from 'ol/format/WKT'
import GeoJSONFormat from 'ol/format/GeoJSON'
import {debounce} from '../../util/misc'
import Vue from "vue";
let wkt = new WktFormat()

export default {
  name: 'search-tool',
  data () {
    return {
      scope: 'all',
      results: [],
      aResults: [],
      showNotFound: false,
      notFoundText: 'Nothing found',
      q: '',
      aq: '',
      aLoading: false,
      availableItemsCount: 5
    }
  },
  created () {
    this.searchScope = null;
    this.gsFormat = new GeoJSONFormat();
  },
  computed: {
    showSearch: {
      get() {
        return this.$store.getters['map/searchShow']
      },
      set(val) {
        this.$store.commit('map/searchShow', val)
      },
    },
    options() {
      let scope = this.getSearchScope()
      let options = [
        {
          value: 'all',
          text: 'All'
        }
      ]

      Object.keys(scope).forEach(k => {
        let fields = scope[k].fields || scope[k]
        options.push({
          text: k + ' ('+fields+')',
          value: {
            layerName: k,
            fields: fields
          }
        })
      })

      return options
    }
  },
  methods: {
    remoteWFSSearch(layerName, fieldName, value) {
      this.aLoading = true
      let cql = escape(`${fieldName} ilike '%${value}%'`)

      Vue.http.get(`/api/gs/wfs?service=wfs&version=2.0.0&request=GetFeature&srsName=EPSG:3857&typeNames=${layerName}&cql_filter=${cql}&COUNT=5&outputFormat=application/json`)
        .then(res => {
          let response = res.body
          if (response.features) {
            response.features.forEach(f => {
              let feat = this.gsFormat.readFeature(f)
              this.results.push({
                name: feat.get(fieldName),
                feature: feat,
                layerName: layerName,
                label: [feat.get(fieldName), layerName].join(' - ')
              })
            })
          }
          this.aLoading = false
        }, res => {
          this.aLoading = false
          Vue.notify({
            title: 'ERROR',
            text: 'Could not search remotely',
            type: 'error'
          })
        })

  //     const wfsXml = `<?xml version="1.0" encoding="UTF-8"?>
  // <wfs:GetFeature xmlns:wfs="http://www.opengis.net/wfs"  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" service="WFS" count="5" version="2.0.0" outputFormat="application/json">
  //           <wfs:Query typeName="${layerName}" cql_filter="${cql}" srsname="EPSG:3857"/>
  //         </wfs:GetFeature>`

      /*const wfsXml = `<wfs:GetFeature service="WFS" version="2.0.0"
  xmlns:lcv="http://inspire.ec.europa.eu/schemas/lcv/3.0"
  xmlns:wfs="http://www.opengis.net/wfs/2.0"
  xmlns:fes="http://www.opengis.net/fes/2.0"
  xmlns:gml="http://www.opengis.net/gml/3.2" count="5" outputFormat="application/json" >
  <wfs:Query typeNames="${layerName}" srsname="EPSG:3857">
    <fes:Filter>
      <fes:PropertyIsLike escape="\" singleChar="_" wildCard="%">
        <fes:ValueReference>${fieldName}</fes:ValueReference>
        <fes:Literal>%${value}%</fes:Literal>
      </fes:PropertyIsLike>
    </fes:Filter>
  </wfs:Query>
</wfs:GetFeature>`

      Vue.http.post('/api/gs/ows', wfsXml, {
        headers: {
          'Content-Type': 'application/xml'
        }
      }).then(res => {
        console.log(res.body)
      }, res => {
        console.error('Could not get layer bounds')
      })*/


    },
    indexSearch () {
      this.showNotFound = false
      this.aResults = []

      this.aLoading = true
      let searchScope = this.getSearchScope()
      let keys = this.scope === 'all' ? Object.keys(searchScope) : [this.scope.layerName]
      let sfn = (search_name) => {
        this.$http.get('/api/search', {
          params: {
            "search_name": search_name,
            "q": this.q
          }
        })
          .then(res => {
            this.aLoading = false
            if (res && res.body) {
              for (let i=0; i < this.results.length; i++) {
                if (this.results[i].layername === search_name) {
                  this.results.splice(i, 1)
                }
              }
              res.body.forEach(item => {

                this.results.push({
                  name: item['label'],
                  label: item['label'],
                  geo: item['geo'],
                  layername: search_name
                })
              })
            }
          }, r => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get search results',
              type: 'error'
            })
          })
      }
      Object.keys(searchScope).forEach(ks => {
        let conf = searchScope[ks]
        if (conf['mode'] === 'full_text' && keys.indexOf(ks) > -1) {
          sfn(ks)
        }
      })
    },
    getSearchScope () {
      if (this.searchScope) {
        return this.searchScope
      }
      let item = this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'search scope')[0]
      if (item) {
        this.searchScope = JSON.parse(item.value)
        return this.searchScope
      }
      return {}
    },
    _search() {
      debounce(this.search, 400)()
    },
    search () {
      this.showNotFound = false
      this.results = []

      this.indexSearch()
      // TODO: improve

      let searchScope = this.getSearchScope()

      let keys = this.scope === 'all' ? Object.keys(searchScope) : [this.scope.layerName]
      let foundFeatures = []
      if (this.q) {
        let layers = this.$mapService.map.getLayers().getArray().filter(l => l instanceof VectorLayer && keys.indexOf(l.get('kegs_name')) > -1)

        layers.forEach(l => {
          let ff = l.getSource().getFeatures().filter(f => {
            return searchScope[l.get('kegs_name')].some(s => {
              if (typeof s === 'string' || s instanceof String) {
                return f.get(s) && f.get(s).toLowerCase().indexOf(this.q.toLowerCase()) > -1
              } else {
                return f.get(s) && f.get(s).toString().toLowerCase().indexOf(this.q.toLowerCase()) > -1
              }

            })
          })
          foundFeatures = foundFeatures.concat(ff.map(f => {
            return {
              feature: f,
              layer: l
            }
          }))
        })

        let layersWms = this.$mapService.map.getLayers().getArray().filter(l => l instanceof TileLayer && keys.indexOf(l.get('kegs_name')) > -1)
        layersWms.forEach(l => {

          searchScope[l.get('kegs_name')].forEach(s => {
            this.remoteWFSSearch(l.get('kegs_name'), s, this.q)
          })
        })
      } else {
        return
      }
      if (foundFeatures.length) {
        foundFeatures.forEach(f => {
          searchScope[f.layer.get('kegs_name')].forEach(s => {
            if (f.feature.get(s) && f.feature.get(s).toString().toLowerCase().indexOf(this.q.toLowerCase()) > -1) {
              this.results.push({
                name: f.feature.get(s),
                feature: f.feature,
                layerName: f.layer.get('kegs_name'),
                label: [f.feature.get(s), f.layer.get('kegs_name')].join(' - ')
              })
            }
          })
        })
        this.results = this.results.sort((a, b) => a['name'].length - b['name'].length).slice(0, this.availableItemsCount)
      } else {
        this.showNotFound = true
      }
    },
    selectAdvancedItem (item) {
      this.aq = ''
      this.aResults = []
      let geo = JSON.parse(item.geo)
      if (geo['coordinates']) {
        let coords = ''
        if (geo['type'] === 'MultiLineString') {
          coords = geo['coordinates'][0]
        } else {
          coords = geo['coordinates']
        }

        var ext = boundingExtent(coords)
        ext = olProj.transformExtent(ext, olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))

        this.$mapService.map.getView().fit(ext,{
          padding: [10, 10, 10, 10]
        })
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'Feature has no coordinates',
          type: 'error'
        })
      }
    },
    selectItem (item) {
      this.q = ''
      this.results = []
      let feat

      if (item.feature) {
        feat = item.feature
      } else {

        feat = wkt.readFeatureFromText(item.geo)
      }


      this.$mapService.map.getView().fit(feat.getGeometry().getExtent(), {
        padding: [10, 10, 10, 10]
      })


      if (feat.getGeometry() instanceof Point) {
        this.$mapService.map.getView().setZoom(16)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/SearchTool.vue